import { render, staticRenderFns } from "./DappDetailedFeed.vue?vue&type=template&id=7b28a4e2&scoped=true"
import script from "./DappDetailedFeed.vue?vue&type=script&lang=ts"
export * from "./DappDetailedFeed.vue?vue&type=script&lang=ts"
import style0 from "./DappDetailedFeed.vue?vue&type=style&index=0&id=7b28a4e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b28a4e2",
  null
  
)

export default component.exports